import { useCallback, useState } from 'react'

const STORAGE_KEY = 'whatsapi_docs_session_key'

export interface SessionApiKey {
  key: string | null
  hasKey: boolean
  setKey: (value: string) => void
  clearKey: () => void
}

export function useSessionApiKey(): SessionApiKey {
  const [key, setKeyState] = useState<string | null>(() => {
    try {
      return sessionStorage.getItem(STORAGE_KEY)
    } catch {
      return null
    }
  })

  const setKey = useCallback((value: string) => {
    try {
      sessionStorage.setItem(STORAGE_KEY, value)
    } catch {
      /* modo privado / quota — mantém só em state */
    }
    setKeyState(value)
  }, [])

  const clearKey = useCallback(() => {
    try {
      sessionStorage.removeItem(STORAGE_KEY)
    } catch {
      /* ignore */
    }
    setKeyState(null)
  }, [])

  return { key, hasKey: key !== null, setKey, clearKey }
}
